import { Loader as GoogleMapsLoader } from 'google-maps'
import getDefaultOptions, { getStartingPosition } from './getDefaultOptions'
import { getSingleMarkerIcon, createMeMarker, createGenericMarker, isCluster } from './markers'
import { icons } from './assets'
import _ from 'lodash'
import { getMarkersToRemove } from './markers';

function createSingleMarker(cp, map, google, onClick, uniqueKey) {
    const icon = getSingleMarkerIcon(cp)
    const marker = new google.maps.Marker({
        position: new google.maps.LatLng(
            cp.coordinates.latitude,
            cp.coordinates.longitude
        ),
        icon: icon,
        shadow: null,
        map,
        m_id: uniqueKey
    })

    google.maps.event.addListener(marker, 'click', () => { onClick(marker, cp) })

    return marker
}

function createClusterMarker(labelContent, pos, map, google, onClick, uniqueKey) {
    const MarkerWithLabel = require('markerwithlabel')(google.maps)

    const marker = new MarkerWithLabel({
        position: new google.maps.LatLng(
            pos.latitude,
            pos.longitude
        ),
        icon: icons.empty.default,
        labelContent,
        labelClass: `cluster-label x${labelContent.length}`,
        shadow: null,
        map,
        m_id: uniqueKey
    })

    google.maps.event.addListener(marker, 'click', () => { onClick(marker) })

    return marker
}
export async function createMap(container, language) {
    const KEY = 'AIzaSyCnC05ng-R6GLHLf3qj64YatkkkjapBf_A'
    const libraries = ['places']

    const loader = new GoogleMapsLoader(KEY, { libraries })
    const google = await loader.load()
    const map = new google.maps.Map(container, getDefaultOptions(google.maps, language))

    return { map, google };
}

export function createMarker(map, marker, google, onSingleMarkerClick, onClusterMarkerClick) {
    return isCluster(marker)
        ? createClusterMarker(
            marker.evseCount.toString(),
            marker.coordinates,
            map,
            google,
            onClusterMarkerClick,
            marker.uniqueKey
        )
        : createSingleMarker(
            marker,
            map,
            google,
            onSingleMarkerClick,
            marker.uniqueKey
        )
}


export function updateMarkers(map, google, fetchMarkers, onSingleMarkerClick, onClusterMarkerClick) {
    return fetchMarkers().then((data) => {
        const markers = _.map(data, (i) => {
            return { data: i, marker: createMarker(map, i, google, onSingleMarkerClick, onClusterMarkerClick) }
        })
        return markers
    })
}

export function removeMarkersFromMap(idsToRemove, currentMapMarkers) {
    idsToRemove.forEach((id) => {
        if (currentMapMarkers[id]) {
            currentMapMarkers[id].setMap(null)
        } else {
            console.log('unable to delete id', id)
        }
    })

    return _(currentMapMarkers)
        .map((marker, id) => { return [id, marker] })
        .filter((a) => { return a[1].getMap() !== null })
        .fromPairs()
        .value()
}

export function extractBounds(map) {
    const bounds = map.getBounds()

    if (!bounds) return null

    const minLng = bounds.getSouthWest().lng()
    const minLat = bounds.getSouthWest().lat()
    const maxLng = bounds.getNorthEast().lng()
    const maxLat = bounds.getNorthEast().lat()
    const zoom = map.getZoom()
    return { minLng, minLat, maxLng, maxLat, zoom }
}

export async function renderMap({ container, language, fetchOnlyMarkers, onSingleMarkerClick, onClusterMarkerClick, allMarkers }) {
    const { map, google } = await createMap(container, language)

    const update = async () => {
        const data = await fetchOnlyMarkers(extractBounds(map));
        const fetchedMarkers = _.map(data, (i) => createMarker(map, i, google, onSingleMarkerClick, onClusterMarkerClick))

        let toRemove = getMarkersToRemove(fetchedMarkers, allMarkers)

        toRemove.forEach(item => item.setMap(null))
        toRemove = []

        allMarkers.push(...fetchedMarkers)
    }

    google.maps.event.addListener(map, 'tilesloaded', update)
    return { map, google }
}

export function refreshMap(map, google) {
    google.maps.event.trigger(map, 'idle')
}

export function goToCurrentPosition(language) {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((pos) => {
                resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude })
            }, reject)
        } else resolve(getStartingPosition(language))
    })
}

export function placeGenericMarker(marker, position, map, google) {
    if (marker) {
        marker.setPosition(position)
        return marker
    } else return createGenericMarker(map, google, position)
}

export function placeMeMarker(meMarker, position, map, google) {
    if (meMarker) {
        meMarker.setPosition(position)
        return meMarker
    } else return createMeMarker(map, google, position)
}

export function goToPosition(map, position) {
    map.panTo(position)
    map.setZoom(16)
}

export function zoomInALittleBit(map, center) {
    const currentZoom = map.getZoom()
    map.setCenter(center)
    map.setZoom(currentZoom + 2)
}

export function centerToMarker(map, marker, offset) {
    const off = offset || -200
    map.panTo(marker.getPosition())
    map.panBy(off, 0)
}
